import { SfTime } from '@app/adapters/time'
import { periodSelectionOptions } from '../constants'

// The date financial_year_exact_date falls back to without one. Keep it in
// line with SegmentFilterRunner#default_date.
const endOfPreviousYear = (): string =>
  SfTime().subtract(1, 'year').endOf('year').format('DD/MM/YYYY')

// The date a period selection runs with when none is stored: the end of last
// year for an exact date option, and null for the others, which run on today.
export const defaultPeriodDate = (
  periodSelection: string | null
): string | null =>
  periodSelectionOptions.some(
    (option) => option.key === periodSelection && option.exactDate
  )
    ? endOfPreviousYear()
    : null

// The stored date, or the default for the period selection's type.
export const periodDate = (
  periodSelection: string | null,
  ledgerSelectDate: string | null
): string | null => ledgerSelectDate || defaultPeriodDate(periodSelection)
